import { Component, h, Host, Prop } from '@stencil/core'

import { IRichAttendee } from '../../../../attendee/types'
import { sortRichAttendees } from '../../../../utils/attendees'

@Component({
  tag: 'page-call-detail-attendees',
})
export class Attendees {
  @Prop() attendees: IRichAttendee[]

  get sortedAttendees() {
    return sortRichAttendees(this.attendees)
  }

  render() {
    return (
      <Host>
        <ul class='flex flex-col text-base spacing-y-2'>
          {this.sortedAttendees.map((attendee) => (
            <page-call-detail-attendee-row attendee={attendee} />
          ))}
        </ul>
      </Host>
    )
  }
}
